import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

const CircularIndeterminate = ({
	marginLeft = '20px',
}: {
	marginLeft?: string
}) => {
	const theme = useTheme()
	return (
		<Box
			sx={{
				ml: marginLeft,
				mr: 3,
				mb: 2,
				mt: 2,
				border: '1px solid',
				borderColor: theme.palette.surface.neutral.skeleton,
				width: '64px',
				height: '48px',
				alignItems: 'center',
				display: 'flex',
				justifyContent: 'center',
				padding: '6px',
				borderRadius: '999px',
				// backgroundColor: theme.palette.background.default,
			}}
		>
			<CircularProgress
			    data-testid="spinner"
				size="25px"
				sx={{ color: theme.palette.foreground.neutral.onSurfaceVar04 }}
			/>
		</Box>
	)
}

export default CircularIndeterminate
